
import CTO from "@model/additional/Cto.js";
// import PERSONALTAILOR from "@model/additional/PersonalTailor.js";
import GIFT from "@model/additional/Gift.js";
import OPTION from "@model/additional/Option.js";
import PACKAGE from "@model/additional/Package.js";
import SERVICE from "@model/additional/Service.js";
import COUPON from "@model/additional/Coupon.js";
import SERVICELIST from "@model/additional/ServiceList.js";
import OPTIONLIST from "@model/additional/OptionList.js";
import GIFTLIST from "@model/additional/GiftList.js";
import SIMILARITYGOODS from "@model/additional/SimilarityGoods.js";
import Factory from "./Factory.js";
import PERSONALGOODS from "@model/additional/PersonalGoods.js";
import ARRIVALGOODS from "@model/additional/ArrivalGoods.js";

export default class AdditionalFactory extends Factory {
    constructor(){
        super();
    }
}

AdditionalFactory.prototype.cto = function(data){
    let _cto = new CTO();
    _cto.init(data);
    return _cto;
}
// AdditionalFactory.prototype.personalTailor = function(data){
//     let _personalTailor = new PERSONALTAILOR();
//     _personalTailor.init(data);
//     return _personalTailor;
// }
AdditionalFactory.prototype.gift = function(data){
    let _gift = new GIFT(data);
    _gift.init(data);
    return _gift;
}

AdditionalFactory.prototype.option = function(data){
    let _option = new OPTION(data);
    _option.init(data);
    return _option;
}

AdditionalFactory.prototype.package = function(data){
    let _package = new PACKAGE(data);
    _package.init(data);
    return _package;
}

AdditionalFactory.prototype.service = function(data){
    let _services = new SERVICE(data);
    _services.init(data);
    return _services;
}

AdditionalFactory.prototype.coupon = function(data){
    let _coupon = new COUPON();
    _coupon.init(data);
    return _coupon;
}

AdditionalFactory.prototype.servicelist = function(data){
    let _serviceList = new SERVICELIST(data);

    _serviceList.init(data);

    return _serviceList;
}
AdditionalFactory.prototype.optionlist = function(data){
    let _optionList = new OPTIONLIST(data);
    _optionList.init(data);
    return _optionList;
}
AdditionalFactory.prototype.giftlist = function(data){
    let _giftList = new GIFTLIST(data);
    _giftList.init(data);
    return _giftList;
}
AdditionalFactory.prototype.similaritygoods = function(data){
    let _similaritygoods = new SIMILARITYGOODS(data);
    _similaritygoods.init(data);
    return _similaritygoods;
}
AdditionalFactory.prototype.personalgoods = function(data){
    let _personalgoods = new PERSONALGOODS(data);
    _personalgoods.init(data);
    return _personalgoods;
}
AdditionalFactory.prototype.arrivalgoods = function(data){
    let _arrivalgoods = new ARRIVALGOODS(data);
    _arrivalgoods.init(data);
    return _arrivalgoods;
}